import React from 'react';
import PropTypes from 'prop-types';
import { Link, Icon, grey600 } from '@paypalcorp/pp-react';

function SocialShareTwitter({ url, handleSocialLinkClick }) {
  return (
    <Link
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'twitter')}
      style={{ color: grey600 }}
      data-testid="social-share-twitter"
    >
      <Icon name="share-twitter" className="ppvx_icon--size_lg" />
    </Link>
  );
}

SocialShareTwitter.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
};

export default SocialShareTwitter;
